import { getEnvironmentProps } from "../../utils/environment";
import { dmnIdentity } from "../../utils/dmnIdentity";
import { errorHandler, apiFetchNotOkHandler } from "../errorHandler";
import { getBuildVersion } from "../getDefaultHeaders";

export type LinkedBookingAction = "confirm" | "reopen" | "reject" | "take";

export const updateLinkedBookingsStatus = async (
  bookingId: string,
  action: LinkedBookingAction
): Promise<boolean> => {
  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  try {
    const response = await fetch(
      `${environmentVars?.COLLINS_API_BASE_URL}/bookings/${bookingId}/linked`,
      {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-Build-Version": getBuildVersion()
        },
        body: JSON.stringify({ action })
      }
    );

    if (response.ok) {
      return true;
    }

    apiFetchNotOkHandler(response, "Error updating linked bookings status");
    return false;
  } catch (error) {
    errorHandler(error, "Error updating linked bookings status");
    return false;
  }
};
